<template>
    <div class="complaint">
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="20">
                <el-row>
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        :inline="true"
                        label-width="100px"
                    >
                        <el-form-item label="留言电话" prop="phone">
                            <el-input
                                class="long"
                                maxlength="12"
                                v-model="ruleForm.phone"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="运单号" prop="waybill">
                            <el-input
                                class="long"
                                maxlength="12"
                                v-model="ruleForm.waybill"
                            ></el-input>
                        </el-form-item>
                        <el-button
                            type="primary"
                            @click="submitForm('ruleForm')"
                            >查询</el-button
                        >
                    </el-form>
                    <el-row
                        class="backg"
                        v-if="isShow"
                        v-for="(item, index) in listContent"
                    >
                        <div class="topmain">
                            <p class="person">留 言 人：{{ item.name }}</p>
                            <p class="time">
                                留言时间：{{ item.created | formatDateMin }}
                            </p>
                        </div>
                        <div class="black">
                            <p class="maintitle">{{ item.title }}</p>
                            <p>{{ item.content }}</p>
                            <p class="line"></p>
                            <div v-if="item.reContent">
                                <p>{{ item.reContent }}</p>
                            </div>
                            <div v-else>
                                <p>{{ mesg }}</p>
                            </div>
                        </div>
                    </el-row>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { queryPageGuestbook } from "@/api/guestBook";
export default {
    name: "proposal",
    data() {
        return {
            isShow: false,
            ruleForm: {
                phone: "",
                waybill: "",
                platform: "1"
            },
            mesg: "暂无回复",
            sumdata: {
                data: {},
                pageIndex: 1,
                pageSize: 2
            },
            listContent: [],
            rules: {
                waybill: [
                    {
                        pattern: /^\d{12}$/,
                        message: "请输入12位数字",
                        trigger: "blur"
                    }
                ],
                phone: [
                    {
                        required: false,
                        message: "请输入电话",
                        trigger: "blur"
                    },
                    {
                        min: 7,
                        max: 12,
                        message: "电话号码7~12位",
                        trigger: "blur"
                    },
                    {
                        pattern: /^[0-9]+$/,
                        message: "只能输入数字"
                    }
                ]
            }
        };
    },
    methods: {
        submitForm(formName) {
            if (this.ruleForm.phone || this.ruleForm.waybill) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.sumdata.data = this.ruleForm;
                        queryPageGuestbook(this.sumdata)
                            .then(res => {
                                if (res.status === 2000) {
                                    this.isShow = true;
                                    this.listContent = res.data;
                                }
                            })
                            .catch(err => {});
                    } else {
                        return false;
                    }
                });
            } else {
                this.$message({
                    message: "请输入查询内容",
                    type: "warning"
                });
            }
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
};
</script>
<style lang="scss" scoped>
.complaint {
    min-height: 514px;
    position: relative;
    .backg {
        margin-top: 20px;
        margin-bottom: 50px;
        background-color: #f5f6f7;
        border-radius: 2px;
        padding: 20px;
        color: #606266;
        // margin-bottom: 20px;
        .topmain {
            .person {
                float: left;
            }
            .time {
                float: right;
            }
            p {
                font-size: 14px;
            }
        }
        .el-textarea {
            width: 600px;
        }
        .el-col-6 {
            margin-bottom: 20px;
        }
        .el-col-12 {
            width: auto;
            margin-bottom: 14px;
            font-size: 14px;
            color: #606266;
            // padding-left: 32px;
        }
        .black {
            margin-top: 50px;
            // margin-bottom: 40px;
            display: block;
            // padding-left: 32px;
            white-space: pre-line;
            word-wrap: break-word;
            word-break: break-all;
            p {
                margin-top: 12px;
                font-size: 15px;
            }
            .maintitle {
                font-size: 16px;
                color: #000;
            }
            .line {
                height: 1px;
                margin-top: 12px;
                background-color: rgba(0, 0, 0, 0.125);
                // color: #fff;
            }
        }
    }
    .el-form {
        width: 860px;
        margin-top: 60px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        .long {
            width: 260px;
        }

        // /deep/ .el-textarea.is-disabled .el-textarea__inner {
        //     background-color: rgba(0, 0, 0, 0) !important;
        //     color: #606266;
        // }
        // .code {
        //     width: 198px;
        // }
        // .tele {
        //     width: 363px;
        // }
        // .btn {
        //     position: relative;
        //     left: 50%;
        //     transform: translateX(-50%);
        //     margin-top: 30px;
        //     margin-bottom: 60px;
        // }
        // .erification {
        //     display: inline-block;
        //     width: 160px;
        //     height: 38px;
        //     border: 1px solid #ccc;
        // }
        // .huanyi {
        //     cursor: pointer;
        //     position: relative;
        //     bottom: 12px;
        //     left: 20px;
        // }
    }
}
</style>
